import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Input, LabelText, SubmitButton, FlexContainer, H1Text, Hr, Text, InputWrapper } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import { API } from "../../api";
import { COUNTRY_PHONE_CODE, EMAIL, PAGES } from "../../appconstants";
import BaseSplitPage from "../../components/splitpage";
import Header from "./smallscreen/header";
import Support from "../../components/support";
import PaymentError from "../../components/paymenterror";
import Select from 'react-select';
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from "libphonenumber-js";
import { InfoCircleOutlined } from "@ant-design/icons";
import { notification } from "antd";

type Props = {
    history: {
        push: Function,
    },
}

const RtpRegister = (props: Props) => {
    const [errorMessage, setErrorMessage] = useState();
    const [success, setSuccess] = useState(false);

    const { handleSubmit, errors, control } = useForm();

    const onSubmit = async (data) => {
        const fullPhone = data?.phone && data?.countryCallingCode
        ? `${data.countryCallingCode.value}${data.phone || ""}`
        : ""
        try {
            const { data: { entity } } = await API.post('/rewards/auth/addUser', {
                email: data.email.trim(),
                password: data.password,
                phoneNumber: fullPhone,
                familyName: data.fname,
                givenName: data.lname
            });
            if (entity.otpRequestId) {
                localStorage.setItem('otpRequestId', entity.otpRequestId);
                localStorage.setItem('phoneNumber', fullPhone);
                setSuccess(true);
                notification.info({
                    className: "alert alert-success",
                    icon: <div className="d-flex align-items-center gap-8">
                    <InfoCircleOutlined style={{ fontSize: '20px' }} />
                    <span style={{ fontSize: '15px' }}>Account is successfuly registered!</span>
                    </div>,
                    duration: 4,
                })
            }
        } catch (e) {
            setErrorMessage(e && e.data ? e?.data?.message : 'Unable to process request. Please try again later');
        }
    }

    useEffect(() => {
        if (success) {
            props.history.replace(PAGES.RTP_OTP_VERIFICATION);
        }
    }, [success]);

    const customInputStyle = {
        background: 'white',
        borderColor: '#CCCCCC',
        width: '100%',
        height: '41px',
        paddingLeft: '15px',
    };

    const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
        return 'The phone number is invalid';
    }
    };

    const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important'
      // maxWidth: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important'
    }),
    };

    return (
        <BaseSplitPage left={
            <>
                <FlexContainer
                    flexDirection="column"
                    position="relative"
                    display="block"
                    height="100%"
                >
                    <div>
                        <H1Text>
                            ACCOUNT REGISTER
                        </H1Text>
                    </div>
                    <div style={{ position: "sticky", top: "85%" }}>
                        <Support email={null}
                            phone={null} />
                    </div>
                </FlexContainer>
            </>
        } right={
            <>
                <Header payment={null} />
                <FlexContainer
                    className="pt-3 pt-lg-5 w-100 p-2"
                    box-shadow="0 0 15px 0 rgba(0, 0, 0, 0.1)"
                    display="flow-root"
                    backgroundColor="#fff"
                    borderRadius="10px"
                    marginTop="5%"
                    marginBottom="5%"
                >
                    <H1Text
                        className="px-1 px-md-4 mt-4"
                    >
                        RTP ACCOUNT SETUP
                    </H1Text>

                    <Text className="px-1 px-md-4" paddingBottom="8px">
                        Register in to your account
                    </Text>
                    <Hr />
                    <div className="px-1 px-md-4 mt-2">
                        <FlexContainer
                            flexDirection="column"
                        >
                            <form onSubmit={handleSubmit(onSubmit)}>
                                {/* register your input into the hook by invoking the "register" function */}
                                <LabelText style={{ color: 'black' }} className="mt-4 mb-2">
                                    First Name
                                </LabelText>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    color={errors.fname ? "red" : "inherit"}
                                    marginBottom="0px"
                                    name="fname"
                                    placeholder="Enter your First Name"
                                    rules={{
                                        required: 'First Name is required'
                                    }}
                                    as={<Input style={customInputStyle} />}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="fname"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                <LabelText style={{ color: 'black' }} className="mt-4 mb-2">
                                    Last Name
                                </LabelText>
                                <Controller
                                    defaultValue={""}
                                    control={control}
                                    color={errors.lname ? "red" : "inherit"}
                                    marginBottom="0px"
                                    name="lname"
                                    placeholder="Enter your Last Name"
                                    rules={{
                                        required: 'Last Name is required'
                                    }}
                                    as={<Input style={customInputStyle} />}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="lname"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                <LabelText style={{ color: 'black' }} className="mt-4 mb-2">
                                    Email
                                </LabelText>
                                <Controller
                                    marginBottom="0px"
                                    defaultValue={""}
                                    control={control}
                                    name="email"
                                    placeholder="Enter your email address"
                                    rules={{
                                        required: 'Email is required',
                                        pattern: {
                                            value: EMAIL.DEFAULT_REGEX,
                                            message: EMAIL.DEFAULT_ERROR_MESSAGE,
                                        },
                                    }}
                                    as={<Input style={customInputStyle} />}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="email"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                <LabelText style={{ color: 'black' }} className="mt-4 mb-2">
                                    Phone
                                </LabelText>
                                <InputWrapper 
                                    className="row" 
                                    display="flex" 
                                    marginTop="8px" 
                                    borderRadius="4px" 
                                    style={{
                                    ...customInputStyle,
                                    }}
                                >
                                    <Controller
                                    defaultValue={{ value: "+1" }}
                                    color={errors.countryCallingCode ? "red" : "inherit"}
                                    marginBottom="0px"
                                    control={control}
                                    name="countryCallingCode"
                                    placeholder="select"
                                    rules={{
                                      required: 'Calling Code is required'
                                    }}
                                    as={<Select
                                        menuPlacement="auto"
                                        getOptionLabel={(option) => option.value}
                                        styles={phoneCustomStyles}
                                        options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />
                                    }
                                    />
                                    <Controller
                                    className="col"
                                    defaultValue={""}
                                    color={errors.phone ? "red" : "inherit"}
                                    border="0px !important"
                                    marginBottom="0px"
                                    marginTop="0px"
                                    marginLeft="0px"
                                    paddingRight="0"
                                    control={control}
                                    name="phone"
                                    rules={{
                                        required: 'This field is required',
                                        validate: isPhoneNumberValidate
                                    }}
                                    as={<NumberFormat
                                        type="tel"
                                        allowNegative={false}
                                        decimalScale={0}
                                        borderRadius="none"
                                        style={{
                                        ...customInputStyle,
                                        height: '39px',
                                        }}
                                    />}
                                    placeholder="Enter phone number"
                                    customInput={Input}
                                    />
                                </InputWrapper>
                                <ErrorMessage
                                    errors={errors}
                                    name="phone"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                <ErrorMessage
                                    errors={errors}
                                    name="countryCallingCode"
                                    render={({ message }) => (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                />
                                <div className="mt-4 mb-2">
                                  <Text>
                                    Already have a Swirepay account? <span style={{ cursor: 'pointer', color: '#007bff' }} onClick={() => props.history.push(PAGES.RTP_LOGIN)}>Sign In</span>
                                  </Text>
                                </div>
                                <div>
                                    <SubmitButton
                                        type="submit"
                                        marginTop="4px"
                                        style={{ width: '292px' }}
                                    >
                                      Register
                                    </SubmitButton>
                                </div>
                                {errorMessage && <PaymentError header={errorMessage} message={null} />}
                            </form>
                        </FlexContainer>
                    </div>
                </FlexContainer>
            </>
        } />
    )
};

export default RtpRegister;
